import { Controller } from 'stimulus';

import ProjectionGraphController from './projection-graph-controller';

class ControllerBase extends Controller {
  projectionGraphTarget: HTMLElement;
}

export default class extends (Controller as typeof ControllerBase) {
  static targets = ['projectionGraph'];

  projectionGraphTarget: HTMLElement;

  handleTabChange() {
    this.projectionGraphController.draw();
  }

  get projectionGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      this.projectionGraphTarget,
      'projection-graph'
    ) as ProjectionGraphController;
  }
}
